export const PE_SEARCH_LOCATIONS = [
  'cdmx',
  'ciudad de méxico',
  ', ags',
  ', aguascalientes',
  ', coah',
  ', chih',
  ', dgo',
  ', durango',
  ', gto',
  ', guanajuato',
  ', jal',
  ', méx',
  ', mich',
  ', N.L',
  ', pue',
  ', qro',
  ', querétaro',
  ', S.L.P',
  ', ver',
  ', yuc'
]

export const MEXICO_STATES = [
  { value: 'Aguascalientes', label: 'Aguascalientes' },
  { value: 'Baja California', label: 'Baja California' },
  { value: 'Baja California Sur', label: 'Baja California Sur' },
  { value: 'Campeche', label: 'Campeche' },
  { value: 'Chiapas', label: 'Chiapas' },
  { value: 'Chihuahua', label: 'Chihuahua' },
  { value: 'Coahuila', label: 'Coahuila' },
  { value: 'Colima', label: 'Colima' },
  { value: 'Ciudad de México', label: 'Ciudad de México' },
  { value: 'Durango', label: 'Durango' },
  { value: 'Guanajuato', label: 'Guanajuato' },
  { value: 'Guerrero', label: 'Guerrero' },
  { value: 'Hidalgo', label: 'Hidalgo' },
  { value: 'Jalisco', label: 'Jalisco' },
  { value: 'México', label: 'México' },
  { value: 'Michoacán', label: 'Michoacán' },
  { value: 'Morelos', label: 'Morelos' },
  { value: 'Nayarit', label: 'Nayarit' },
  { value: 'Nuevo León', label: 'Nuevo León' },
  { value: 'Oaxaca', label: 'Oaxaca' },
  { value: 'Puebla', label: 'Puebla' },
  { value: 'Querétaro', label: 'Querétaro' },
  { value: 'Quintana Roo', label: 'Quintana Roo' },
  { value: 'San Luis Potosí', label: 'San Luis Potosí' },
  { value: 'Sinaloa', label: 'Sinaloa' },
  { value: 'Sonora', label: 'Sonora' },
  { value: 'Tabasco', label: 'Tabasco' },
  { value: 'Tamaulipas', label: 'Tamaulipas' },
  { value: 'Tlaxcala', label: 'Tlaxcala' },
  { value: 'Veracruz', label: 'Veracruz' },
  { value: 'Yucatán', label: 'Yucatán' },
  { value: 'Zacatecas', label: 'Zacatecas' }
]

export const MONTHS = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' }
]

export const PROPERTY_TYPES_OPTIONS = [
  { value: 'HOUSE', label: 'Casa' },
  { value: 'DUPLEX_HOUSE', label: 'Casa Duplex' },
  { value: 'COUNTRY_HOUSE', label: 'Quinta Campestre' },
  { value: 'APARTMENT', label: 'Departamento' },
  { value: 'OFFICE', label: 'Oficina' },
  { value: 'CONSULTING_ROOM', label: 'Consultorio' },
  { value: 'WAREHOUSE', label: 'Bodega' },
  { value: 'INDUSTRIAL_BUILDING', label: 'Nave industrial' },
  { value: 'SHOP', label: 'Local' },
  { value: 'SHOP_SHOPPING_CENTER', label: 'Local en centro comercial' },
  { value: 'TERRAIN', label: 'Terreno/Lote' },
  { value: 'RANCH', label: 'Rancho/Hacienda' },
  { value: 'BUILDING', label: 'Edificio' },
  { value: 'HOTEL', label: 'Hotel' },
  { value: 'EVENT_HALL', label: 'Salón/Terraza de eventos' },
  { value: 'COTTAGE', label: 'Cabaña' },
  { value: 'OTHER', label: 'Otro' }
]

export const OPERATION_TYPES_OPTIONS = [
  { value: 'PRESALE', label: 'Preventa' },
  { value: 'SALE', label: 'Venta' },
  { value: 'LEASE', label: 'Renta' }
]

// Form validation constants
export const MAX_LEGAL_STATUS_CHARACTERS = 500
